import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { BookingsState, Booking } from './bookingsTypes';
import { bookingsAPI } from './bookingsAPI';

const initialState: BookingsState = {
  bookings: [],
  currentBooking: null,
  loading: false,
  error: null,
};

const bookingsSlice = createSlice({
  name: 'bookings',
  initialState,
  reducers: {
    setCurrentBooking: (state, action: PayloadAction<Booking | null>) => {
      state.currentBooking = action.payload;
    },
    clearBookingsError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      bookingsAPI.endpoints.getBookings.matchPending,
      (state) => {
        state.loading = true;
        state.error = null;
      }
    );
    builder.addMatcher(
      bookingsAPI.endpoints.getBookings.matchFulfilled,
      (state, action) => {
        state.loading = false;
        state.bookings = action.payload;
      }
    );
    builder.addMatcher(
      bookingsAPI.endpoints.getBookings.matchRejected,
      (state, action: any) => {
        state.loading = false;
        state.error = action.error?.message || 'Failed to fetch bookings';
      }
    );
  },
});

export const { setCurrentBooking, clearBookingsError } = bookingsSlice.actions;
export default bookingsSlice.reducer;
